import http from '@axios'
import paramsConverter from './utils/paramsConverter'

const resource = '/api/v1/evoting'

export default {
  list(params = {}) {
    const paramsString = paramsConverter(params)

    return http.get(`${resource}${paramsString}`)
  },
  get(uuid) {
    return http.get(`${resource}/${uuid}`)
  },
  add(evoting) {
    return http.post(`${resource}`, evoting)
  },
  update(evoting, uuid) {
    return http.post(`${resource}/${uuid}?_method=PATCH`, evoting)
  },
  destroy(uuid) {
    return http.delete(`${resource}/${uuid}`)
  },
}
